import { useTranslation } from 'react-i18next'
import { useLocation, useParams } from 'react-router-dom'

import { ImageGalleryWrapper } from 'entities/kyrgyzstan/ui/image-gallery-wrapper'

import type { RealtyObject } from 'shared/api/kyrgyzstan/search'

interface OrderGalleryImageLocationState {
  realty?: RealtyObject
}

const KyrgyzstanOrderDetailGalleryImagePage = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const { imageIndex } = useParams<{ orderId: string; imageIndex: string }>()

  const realtyData =
    (location.state as OrderGalleryImageLocationState)?.realty ?? null
  const initialIndex = Number(imageIndex) || 0

  return (
    <ImageGalleryWrapper
      images={realtyData?.images || []}
      title={realtyData?.title || ''}
      initialIndex={initialIndex}
      isLoading={false}
      error={!realtyData ? t('kyrgyzstan_block.error.title') : null}
    />
  )
}

export default KyrgyzstanOrderDetailGalleryImagePage
